module.exports = __webpack_public_path__ + "img/photo-0030.52744c40.jpg";